import { Reveal } from "@/components/site/Reveal";
import { BookingDialog } from "@/components/site/BookingDialog";
import { ArrowRight, Phone } from "lucide-react";
import { BRAND } from "@/lib/content";

export const FinalCTA = () => {
  return (
    <section className="relative overflow-hidden bg-[color:var(--bp-bg-2)] section-py" data-testid="final-cta-section">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{ background: "radial-gradient(720px 420px at 50% 0%, rgba(45,181,165,0.16), transparent 62%)" }}
      />
      <div className="container-bp relative">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <p className="eyebrow inline-flex items-center justify-center gap-2 text-[color:var(--bp-teal)]">
              <span className="h-px w-8 bg-[color:var(--bp-teal)]" /> Let&apos;s talk
            </p>
            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.1] tracking-[-0.01em] text-[color:var(--bp-cream)] sm:text-5xl">
              Ready to go beyond conventional recruitment?
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-[color:var(--bp-text-muted)] sm:text-base">
              Book a confidential 15-minute briefing. We&apos;ll discuss your specific talent challenge and share market intelligence relevant to your situation.
            </p>
            <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <BookingDialog
                trigger={
                  <button data-testid="final-cta-book-button" className="group inline-flex items-center justify-center gap-2 rounded-full bg-[color:var(--bp-teal)] px-8 py-4 text-sm font-semibold text-[color:var(--bp-bg)] shadow-[var(--shadow-soft)] transition-shadow hover:shadow-[var(--shadow-lift)]">
                    Book Your Confidential Briefing
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </button>
                }
              />
              <a href={`tel:${BRAND.phoneMonaco.replace(/\s+/g, "")}`} className="inline-flex items-center gap-2 rounded-full border border-[color:var(--bp-border)] px-7 py-4 text-sm font-medium text-[color:var(--bp-cream)] transition-colors hover:border-[color:var(--bp-teal)]">
                <Phone className="h-4 w-4 text-[color:var(--bp-teal)]" /> Call Monaco
              </a>
            </div>
            <p className="mt-7 flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-[11px] uppercase tracking-[0.14em] text-[color:var(--bp-text-muted)]/70">
              <span>No obligation</span><span aria-hidden>·</span><span>100% confidential</span><span aria-hidden>·</span><span>Reply within 4 business hours</span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
